import { useState } from 'react';
/**
 * Returns a prefixed unique identifier.
 * @function useIdent
 * @since 1.0.0
 */
export function useIdent(base) {
    const [ident, setIdent] = useState(base + '-' + Math.random().toString(36).substr(2, 9));
    return [ident, setIdent];
}
